import {ValueRetrieverBase} from "./Core/ValueRetrieverBase";
import {ComparisonTypeEnum} from "../../Fields/Core/ConditionOptions";

export class NumericValueRetriever extends ValueRetrieverBase{


    GetValue() {
        return this.Source.GetValue();
    }

    Compare(Comparison: ComparisonTypeEnum, Value: any) {

        if(!this.Source.GetIsVisible())
            return false;
        let selectedValue=this.GetValue();

        switch (Comparison) {
            case ComparisonTypeEnum.Equal:
                return this.Source.GetIsUsed()&&selectedValue==Value;
            case ComparisonTypeEnum.NotEqual:
                return selectedValue!=Value;
            case ComparisonTypeEnum.IsEmpty:
                return this.Source.GetIsUsed();
            case ComparisonTypeEnum.IsNotEmpty:
                return !this.Source.GetIsUsed();
            case ComparisonTypeEnum.GreaterThan:
                return this.Source.GetIsUsed()&&selectedValue>Value;
            case ComparisonTypeEnum.GreaterOrEqualThan:
                return this.Source.GetIsUsed()&&selectedValue>=Value;
            case ComparisonTypeEnum.LessThan:
                return this.Source.GetIsUsed()&&selectedValue<Value;
            case ComparisonTypeEnum.LessOrEqualThan:
                return this.Source.GetIsUsed()&&selectedValue<=Value;

        }
    }



}